import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer, withText } from 'preact-i18n';
import Markdown from 'preact-markdown';

import localUtil from '../../lib/util';
import fields from '../../lib/fields';

import FormFields from '../form/fields';
import Input from '../form/input';
import Versions from '../versions';

@withText(props => ({
    orderNumber: <Text id='input.orderNumber-help'>orderNumber</Text>,
    name: <Text id='input.name-help'>name</Text>,
    description: <Text id='input.description-help'>description</Text>,
    installation: <Text id='input.installation-help'>installation</Text>,
    url: <Text id='input.url-help'>url</Text>,
}))
@observer
class NewSalePayment extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            sections: fields.get('salePayment'),
        };
    }

    createSalePayment = async () => {
        const { callback = () => {} } = this.props;
        const { salePaymentStore } = this.props.stores;
        const { newSalePayment } = salePaymentStore;
        const response = await salePaymentStore.insert(newSalePayment);
        const salePayment = response?.data?.salePayment;
        salePaymentStore.updateKeyValue('newSalePayment', {});
        if (response.status === 201) {
            callback(salePayment);
        }
    }

    componentDidMount() {
        const { id, isNew } = this.props;
        const { salePaymentStore } = this.props.stores;
        if (!isNew) {
            salePaymentStore.load(id);
        }
    }

    render() {
        const { week, isNew, hideAdmin, drawerLevel } = this.props;
        const { sections } = this.state;
        const { userStore, salePaymentStore } = this.props.stores;
        const { user, isAdmin } = userStore;
        const { newSalePayment, salePayment } = salePaymentStore;
        const darkmode= util.getNestedValue(user, 'settings.darkmode');

        return (<>
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 960px; padding-top: 20px; padding-bottom: 100px;'>

                    {/* Version history for existing salePayments */}
                    {!isNew && salePayment?.id && <Versions stores={this.props.stores} type='salePayment' id={salePayment.id} key={`salePayment-${salePayment.id}`} />}

                    {/* <div class='w-100 d-flex flex-column justify-content-start'>
                        <xmp>{JSON.stringify(user.settings, null, 2)}</xmp>
                    </div> */}
                    {/* <xmp>{JSON.stringify(newSalePayment, null, 4)}</xmp> */}
                    <div class='font-weight-lighter px-3 box-header mt-0'>
                        {isNew ? <Text id='salePayment.new'>New salePayment</Text> : <Text id='salePayment.edit'>Edit salePayment</Text>}
                    </div>
                    <div class='bg-light d-flex flex-column justify-content-start h-100 pt-3'>
                        <FormFields
                            stores={this.props.stores}
                            sections={sections}
                            holdingStore={salePaymentStore}
                            objectName={isNew ? 'newSalePayment' : 'salePayment'}
                            isNew={isNew}
                            drawerLevel={drawerLevel}
                            hideAdmin={hideAdmin}
                        />
                    </div>
                    {isNew && <div class='w-100 d-flex flex-column justify-content-start mt-3 px-4 py-3 bg-light fixed-bottom' style={`bottom: 0; left: 0;`}>
                        <button type='button' class='btn btn-primary rounded-pill' onClick={this.createSalePayment}>
                            {isNew ? <Text id='salePayment.create'>Create salePayment</Text> : <Text id='salePayment.save'>Save salePayment</Text>}
                        </button>
                    </div>}
                </div>
            </div>
        </>);
    }
}

export default NewSalePayment;
